import { render, staticRenderFns } from "./StsDownloadButton.vue?vue&type=template&id=a5fd3a28&"
import script from "./StsDownloadButton.vue?vue&type=script&lang=js&"
export * from "./StsDownloadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports